import * as React from "react";
const SvgFiRrTruckArrowLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 5h-2.101a5.01 5.01 0 0 0-4.9-4H4.466c-1.78 0-3.44.958-4.33 2.5a1 1 0 1 0 1.73 1.001 3.01 3.01 0 0 1 2.6-1.5H12c1.654 0 3 1.346 3 3v11H3.829a2.01 2.01 0 0 1-1.887-1.333.999.999 0 1 0-1.884.666 4 4 0 0 0 2.994 2.581 3.5 3.5 0 0 0-.052.586c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-.169-.017-.335-.041-.5h4.082a3.5 3.5 0 0 0-.041.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5a3.4 3.4 0 0 0-.061-.623c1.752-.425 3.06-1.996 3.06-3.877v-5A5.007 5.007 0 0 0 19 5m3 5v1h-5V7h2c1.654 0 3 1.346 3 3M8 19.5c0 .827-.673 1.5-1.5 1.5S5 20.327 5 19.5c0-.19.039-.356.093-.5h2.814c.054.144.093.31.093.5m9.5 1.5c-.827 0-1.5-.673-1.5-1.5 0-.19.039-.356.093-.5h2.814c.054.144.093.31.093.5 0 .827-.673 1.5-1.5 1.5m2.5-4h-3v-4h5v2c0 1.103-.897 2-2 2M4.768 7.232 3 9h7.035a1 1 0 1 1 0 2H3l1.768 1.768a.999.999 0 1 1-1.414 1.414L.586 11.414a2 2 0 0 1 0-2.828l2.768-2.768a.999.999 0 1 1 1.414 1.414"
    />
  </svg>
);
export default SvgFiRrTruckArrowLeft;
